module.exports = __webpack_public_path__ + "static/media/assassin3.3b9f65b6.png";